<template>
  <div v-if="beaconMessageData" class="form-container">
    <div style="margin-left: 150px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form ref="form" :model="beaconMessageData" label-width="150px" label-position="left">
      <el-form-item label="識別名稱">
        <el-input v-model="beaconMessageData.title"></el-input>
      </el-form-item>
      <el-form-item label="有效時間">
        <el-row class="text-flex-content">
          <el-date-picker
            v-model="beaconMessageData.started_at"
            type="date"
            placeholder="YYYY/MM/DD"
            format="yyyy/MM/dd"></el-date-picker>
          <span class="divider"> - </span>
          <el-date-picker
            v-model="beaconMessageData.ended_at"
            type="date"
            placeholder="YYYY/MM/DD"
            format="yyyy/MM/dd"></el-date-picker>
        </el-row>
      </el-form-item>
      <el-form-item label="狀態">
        <div
          class="beacon-message-status-content"
          @click="beaconMessageData.status = !beaconMessageData.status">
          <span
            class="beacon-message-status"
            :class="{ active: beaconMessageData.status }">
            {{ beaconMessageData.status ? '啟用' : '未啟用' }}
          </span>
        </div>
      </el-form-item>
      <el-form-item label="推播圖片">
        <el-upload
          action=""
          :file-list="uploadImages"
          :auto-upload="false"
          :limit="5"
          list-type="picture-card"
          class="tfam-upload"
          :on-change="handleFileChange"
          accept="image/*"
          multiple>
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
            <img
              class="el-upload-list__item-thumbnail"
              style="object-fit: cover"
              :src="file.url" alt="">
            <div class="picture-card-style-control">
              <span class="file-name">{{ file.name }}</span>
              <span
                class="remove-button"
                @click="handleRemoveFile(file)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </el-upload>
        <div :style="{ marginTop: uploadImages.length > 0 ? '0' : '20px'}">
          <el-button plain @click="removeUploadImage">移除所選檔案</el-button>
        </div>
      </el-form-item>
      <el-form-item label="推播訊息">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="beaconMessageData[currentLang].content"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="tfam-button" plain v-loading.fullscreen.lock="fullLoading" @click="handleSubmitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <el-button class="tfam-button" plain @click="deleteRowData">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { fetchBeaconMessage, createBeaconMessage, updateBeaconMessage, createBeaconMessageLang, updateBeaconMessageLang } from "../../api/beaconMessage";
  import { getGCPFileUrl, storageUploadFiles } from "../../api/attachment";
  import { createImage, deleteImage } from "../../api/image";
  import lodash from 'lodash'

  export default {
    name: "BeaconNotificationEdit",
    data() {
      return {
        currentLang: 'ZH_TW',
        langList: this.$store.getters.langList,
        uploadImages: [],
        beaconMessageId: undefined,
        beaconMessageData: undefined,
        originalBeaconMessageData: undefined,
        fullLoading: false
      }
    },
    methods: {
      handleRemoveFile(file) {
        let index = -1;
        for (const i in this.uploadImages) {
          if (this.uploadImages[i]['uid'] === file['uid']) {
            index = parseInt(i);
            break
          }
        }
        if (index >= 0) {
          this.uploadImages.splice(index, 1);
        }
      },
      handleFileChange(file, fileList) {
        this.uploadImages = fileList;
      },
      removeUploadImage() {
        this.setupUploadImageList();
      },
      setupUploadImageList() {
        this.uploadImages = [];
        for (const i in this.originalBeaconMessageData.images) {
          setTimeout(() => {
            const uid = new Date().getTime();
            const imageData = lodash.cloneDeep(this.originalBeaconMessageData.images[i]);
            this.uploadImages.push({
              name: imageData['original_name'],
              url: getGCPFileUrl(imageData['name']),
              uid: uid,
              status: 'success',
              data: imageData
            })
          }, 100);
        }
      },
      getBeaconMessageData() {
        this.fullLoading = true;
        const filter = {
          include: ['beaconMessageLangs', 'images']
        };
        fetchBeaconMessage(this.beaconMessageId, filter).then(response => {
          console.log('fetchBeaconMessage SUCCESS');
          this.fullLoading = false;
          const beaconData = response.data;
          for (const i in this.langList) {
            const lang = this.langList[i]['language_key'];
            const filter = beaconData['beaconMessageLangs'].filter(x => x['language_key'] === lang);
            if (filter.length > 0) {
              beaconData[lang] = JSON.parse(JSON.stringify(filter[0]));
            } else {
              beaconData[lang] = {};
              beaconData[lang].beacon_message_lang_id = 'new';
              beaconData[lang].language_key = lang;
              beaconData[lang].content = '';
            }
          }
          this.beaconMessageData = JSON.parse(JSON.stringify(beaconData));
          this.originalBeaconMessageData = JSON.parse(JSON.stringify(beaconData));
          this.setupUploadImageList();
        }).catch(err => {
          this.fullLoading = false;
        })
      },
      handleSubmitUpdate() {
        this.fullLoading = true;
        this.submitUpdate().then(response => {
          this.fullLoading = false;
          this.$message({
            type: 'success',
            message: '儲存成功!'
          });
          if (this.beaconMessageId === 'new') {
            this.beaconMessageId = response;
            this.$router.push({
              path: '/notification/beacon/' + response
            });
          }
          this.getBeaconMessageData();
        }).catch(err => {
          console.log(err);
          let message = err;
          if (err.response) {
            message = err.response.data.error.message + '!'
          }
          this.$alert(message, '儲存失敗', {
            confirmButtonText: '確定',
            callback: action => {
            }
          });
          this.fullLoading = false;
        })
      },
      submitUpdate: async function() {
        try {
          let beaconMessageId = this.beaconMessageId;
          const beaconMessageData = lodash.cloneDeep(this.beaconMessageData);
          if (beaconMessageId === 'new') {
            const newBeaconMsg = await createBeaconMessage(beaconMessageData);
            beaconMessageId = newBeaconMsg.data['beacon_message_id'];
          } else {
            await updateBeaconMessage(beaconMessageId, this.beaconMessageData)
          }
          let saveImageList = [];
          for (const i in this.uploadImages) {
            const image = this.uploadImages[i];
            if (image['status'] === 'success' && image['data']) {
              saveImageList.push(image['data'])
            } else if (image['raw']) {
              const uploadImageResult = await storageUploadFiles([image['raw']]);
              const files = uploadImageResult.data.result.files.file;
              const newImageData = await createImage({
                name: files[0]['name'],
                original_name: files[0]['originalFilename'],
                object_id: beaconMessageId
              });
              saveImageList.push(newImageData)
            }
          }
          for (const i in this.originalBeaconMessageData.images) {
            const imageData = this.originalBeaconMessageData.images[i];
            const filterNewImageList = saveImageList.filter(x => x['image_id'] === imageData['image_id']);
            if (filterNewImageList.length === 0) {
              await deleteImage(imageData['image_id'])
            }
          }
          for (const i in this.langList) {
            const beaconMessageLang = this.beaconMessageData[this.langList[i]['language_key']];
            if (beaconMessageLang['beacon_message_lang_id'] === 'new') {
              beaconMessageLang['beacon_message_id'] = beaconMessageId;
              await createBeaconMessageLang(beaconMessageLang);
            } else {
              await updateBeaconMessageLang(beaconMessageLang['beacon_message_lang_id'], beaconMessageLang);
            }
          }
          return Promise.resolve(beaconMessageId);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      goBack() {
        this.$router.push({
          path: '/notification/beacon/'
        });
      },
      deleteRowData() {
      }
    },
    mounted() {
      this.beaconMessageId = this.$route.params.beaconMessageId;
      if (this.beaconMessageId !== 'new') {
        this.getBeaconMessageData();
      } else {
        this.fullLoading = false;
        const beaconData = {
          beacon_message_id: 'new',
          title: '',
          started_at: undefined,
          ended_at: undefined,
          message_type: 0,
          status: true,
          images: []
        };
        for (const i in this.langList) {
          const lang = this.langList[i]['language_key'];
          beaconData[lang] = {};
          beaconData[lang].beacon_message_lang_id = 'new';
          beaconData[lang].language_key = lang;
          beaconData[lang].content = '';
        }
        this.beaconMessageData = beaconData;
        this.originalBeaconMessageData = lodash.cloneDeep(beaconData);
        this.setupUploadImageList();
      }
    }
  }
</script>

<style lang="scss">
  .text-flex-content {
    display: flex;
    .divider {
      padding: 0 10px;
    }
  }
  .beacon-message-status-content {
    height: 30px;
    width: fit-content;
    line-height: 30px;
    border: rgba(68, 68, 68, .5) 1px solid;
    border-radius: 10em;
    transition: .2s ease-out;
    padding: 0 1em;
    margin: 5px;
    cursor: pointer;
    .beacon-message-status:before {
      content: '';
      display: inline-block;
      width: .5rem;
      height: .5rem;
      background: red;
      border-radius: 100%;
      margin-right: .5rem;
    }
    .beacon-message-status.active:before {
      background: #82C9A6;
    }
  }
  /*.beacon-message-status {*/
  /*  border: rgba(68, 68, 68, .5) 1px solid;*/
  /*  border-radius: 10em;*/
  /*  transition: .2s ease-out;*/
  /*  padding: 0 1em;*/
  /*}*/
  .audio-name {
    width: auto;
    /*height: 70px;*/
    padding: 0 20px;
    background-color: white;
    margin-right: 10px;
    /*margin: 10px 0;*/
    span {
      font-size: 14px;
      line-height: 40px;
      color: #222;
    }
  }
  .room-options {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: contain;
  }
</style>
